export enum AssistedSessionType {
  NONE,
  REMOTE_CONTROL,
  ASSISTED_BROWSING
}
